import React from "react";
import "./style.css";

const ReasonInput = ({ value, onChange }) => {
  // Safe fallback if value is undefined or null
  var currentValue = value || "";

  const handleChange = (e) => {
    var input = e.target.value;

    // Optional sanitization (uncomment if backend can't handle Turkish letters)
    //   const sanitized = input
    // .replace(/ö/g, "o")
    // .replace(/ü/g, "u")
    // .replace(/ğ/g, "g")
    // .replace(/ç/g, "c")
    // .replace(/ş/g, "s")
    // .replace(/ı/g, "i")
    // .replace(/İ/g, "I");

    if (input.length <= 480) {
      onChange(input);
    }
  };

  var charCount = currentValue.length;
  var isTooShort = charCount > 0 && charCount < 10;

  return (
    <div className="reason-input">
      <label>Atama Nedeni</label>
      <textarea
        value={currentValue}
        onChange={handleChange}
        placeholder="Atama nedenini giriniz..."
        className={"textarea-field" + (isTooShort ? " invalid" : "")}
        minLength="10"
        maxLength="500"
      />
      <div className="char-counter">
        {charCount}/480
        {isTooShort ? (
          <span className="error-text"> (En az 10 karakter)</span>
        ) : null}
      </div>
    </div>
  );
};

export default ReasonInput;
